import { InfiniteScroll } from "../../../../../shared/infrastructure";
import { OfferCard2 } from "../components";
import React from "react";
import { useInfiniteGetOffers } from "../../services";
import { useOfferNotification, useOffers } from "../../store";

export const OffersQueue = (): React.ReactElement => {
  const {
    queueFilters,
    newOffers,
    updatedOffers,
    deletedOffers,
    statusChangedOffers,
  } = useOffers();
  const label = useOfferNotification("queue");
  const { allPages, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteGetOffers("queue", queueFilters);

  return (
    <React.Fragment>
      <section>{label}</section>
      <section className="h-[90%] max-h-[100%] overflow-y-auto">
        <section className="relative mx-auto grid gap-[12px] pb-[60px] xl:w-[1096px] 2xl:w-[1470px]">
          <InfiniteScroll
            isLoading={isLoading || isFetching}
            hasNextPage={!!hasNextPage}
            loadMore={fetchNextPage}
            renderItem={(offer) => (
              <OfferCard2
                key={offer.approval_id}
                data={offer}
                cardType="queue"
                showHighlighted={
                  newOffers[offer.approval_id.toString()] ||
                  updatedOffers[offer.approval_id.toString()]
                }
                isManaged={
                  statusChangedOffers[offer.approval_id.toString()] !==
                    undefined ||
                  updatedOffers[offer.approval_id.toString()] === false
                }
                isRemoved={
                  deletedOffers[offer.approval_id.toString()] !== undefined
                }
              />
            )}
            data={allPages}
          />
          {isLoading && (
            <p className="mb-[50px] text-center text-[14px]">
              Loading offers...
            </p>
          )}
          {!isLoading && allPages.length === 0 && (
            <p className="mb-[50px] text-center text-[14px]">
              There are no offers to load
            </p>
          )}
        </section>
      </section>
    </React.Fragment>
  );
};
